/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import Repository from '@/libs/axios'
import OperationsRepository from '@/libs/customAxios/operationAxios'

const ticketResource = '/admin/ticket'

const defaultPagination = 5

export default {
  getTicketTypes() {
    return OperationsRepository.get(`${ticketResource}-types`)
  },
  getAllTickets(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${ticketResource}?${filterQuery}&page=${pageNumber}&paginate=${pagination}`)
  },
  getAllTicketsNoPagination(filterQuery) {
    return Repository.get(`${ticketResource}?${filterQuery}&noPagination`)
  },
  getPickupRequests(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${ticketResource}-pickup-requests?${filterQuery}&page=${pageNumber}&paginate=${pagination}`)
  },
  getPickupRequestsNoPagination(filterQuery) {
    return Repository.get(`${ticketResource}-pickup-requests?${filterQuery}&noPagination`)
  },
  getTicketById(id) {
    return OperationsRepository.get(`${ticketResource}/${id}`)
  },
  getPickupRequestById(id) {
    return OperationsRepository.get(`${ticketResource}-pickup-request/${id}`)
  },
  getTicketConvos(id) {
    return OperationsRepository.get(`${ticketResource}/${id}/convos`)
  },
  createTicket(formData) {
    return Repository.post(`${ticketResource}`, formData)
  },
  updateTicket(id, payload) {
    const formData = new FormData()
    for (const key in payload) {
      formData.append(key, payload[key])
    }
    return Repository.post(`${ticketResource}/${id}/convos`, formData)
  },
  closeTicket(id) {
    return Repository.post(`${ticketResource}/${id}/close`)
  },
  openTicket(id) {
    return Repository.post(`${ticketResource}/${id}/open`)
  },
  getTicketStatusStatistics() {
    return Repository.get('/admin/dashboard/ticket/tickets-status-statistics')
  },
  getTicketByType() {
    return Repository.get('/admin/dashboard/ticket/tickets-by-type')
  },
  getTicketByMerchant(limit = null) {
    return Repository.get(`/admin/dashboard/ticket/tickets-by-merchant${limit ? `?limit=${limit}` : ''}`)
  },
  getTicketByDate() {
    return Repository.get('/admin/dashboard/ticket/tickets-by-date')
  },
  getTicketByBranch(limit = null) {
    return Repository.get(`/admin/dashboard/ticket/tickets-by-branch${limit ? `?limit=${limit}` : ''}`)
  },
  getTicketByAssignee(limit = null) {
    return Repository.get(`/admin/dashboard/ticket/tickets-by-assignee${limit ? `?limit=${limit}` : ''}`)
  },
  updateTicketStatus(id, status, statusName) {
    return Repository.post(`${ticketResource}/${id}/update-status?status=${status}&statusName=${statusName}`)
  },
  getTicketSummary() {
    return Repository.get(`${ticketResource}-status-counts`)
  },
  getDataByWaybill(waybill) {
    return Repository.get(`${ticketResource}-order-data?waybill=${waybill}`)
  },
}
